import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
// Wraps the HR "registration drawer" once it's swapped into the layout's
// persistent #modal turbo-frame. Opening/closing happens entirely client-side,
// so the page that triggered it is never navigated away from.
export default class extends Controller {
  static targets = ["backdrop", "panel"]

  connect() {
    requestAnimationFrame(() => {
      this.backdropTarget.classList.remove("opacity-0")
      this.panelTarget.classList.remove("translate-x-full")
    })
  }

  backdropClick(event) {
    if (event.target === this.backdropTarget) this.close(event)
  }

  close(event) {
    event?.preventDefault()
    this.backdropTarget.classList.add("opacity-0")
    this.panelTarget.classList.add("translate-x-full")
    setTimeout(() => this.element.remove(), 200)
  }
}
